import { Button, MenuItem } from '@blueprintjs/core';
import { Select } from '@blueprintjs/select';
import axios from 'axios';
import React, {Component} from 'react';
import toastr from 'toastr';
import { getJwt, setCurrentUserName } from '../../../services/authService';
import http from '../../../services/httpService';
import countries from '../../common/countries.json';

class DateTime extends Component {
    state = {
        timeZones: [],
        filteredTimeZones: [],
        selectedTimeZone: {
            "objectId": "wDGIKmU1BW",
            "CountryCode": "RS",
            "TimeZone": "Europe/Belgrade",
            "UTC_Jan_1_2020": 1,
            "createdAt": "2020-02-11T18:48:43.540Z",
            "updatedAt": "2020-02-11T19:24:14.416Z"
        },
        selectedDateFormat: 'DD-MM-YYYY',
        selectedTimeFormat: '24-hour clock',
        dataBeforeChange:{
            selectedTimeZone: {
                "objectId": "wDGIKmU1BW",
                "CountryCode": "RS",
                "TimeZone": "Europe/Belgrade",
                "UTC_Jan_1_2020": 1,
                "createdAt": "2020-02-11T18:48:43.540Z",
                "updatedAt": "2020-02-11T19:24:14.416Z"
            },
            selectedDateFormat: 'DD-MM-YYYY',
            selectedTimeFormat: '24-hour clock',
        },
        shouldBeUpdated: false
    }
    async componentDidMount(){
        try{

            const response = await axios(
                `https://parseapi.back4app.com/classes/Time_Zones_Dataset?limit=1000&order=UTC_Jan_1_2020&excludeKeys=Country,DST_Jul_1_2020`,
                {
                    headers: {
                        'X-Parse-Application-Id': 'AeFZ3ZNJ0k8vTBJckXzUvguaR30uhosrDGdvAXtN', // This is the fake app's application id
                        'X-Parse-Master-Key': 'ypQIcKerRaMCPVLYYeTvg0gdqyiDBZB3unKAVNQX', // This is the fake app's readonly master key
                    }
                }
            );
            if(this.props.user.locals){
                let locals = this.props.user.locals
                this.setState({
                    selectedTimeZone: {
                        TimeZone: locals.timezone,
                        UTC_Jan_1_2020: locals.offset
                    },
                    selectedDateFormat: locals.date_format,
                    selectedTimeFormat: locals.time_format,
                    dataBeforeChange:{
                        selectedTimeZone: {
                            TimeZone: locals.timezone,
                            UTC_Jan_1_2020: locals.offset
                        },
                        selectedDateFormat: locals.date_format,
                        selectedTimeFormat: locals.time_format
                    }
                })
            }
            await this.setState({timeZones: response.data.results, filteredTimeZones: response.data.results})
        }catch(e) {

        }
    }

    componentDidUpdate(){
        if(this.state.shouldBeUpdated){
            this.props.updateUserFromServer();
            let locals = this.props.user.locals
            // console.log('locals: ', locals)
            this.setState({
                selectedTimeZone: {
                    TimeZone: locals.timezone,
                    UTC_Jan_1_2020: locals.offset
                },
                selectedDateFormat: locals.date_format,
                selectedTimeFormat: locals.time_format,
                dataBeforeChange:{
                    selectedTimeZone: {
                        TimeZone: locals.timezone,
                        UTC_Jan_1_2020: locals.offset
                    },
                    selectedDateFormat: locals.date_format,
                    selectedTimeFormat: locals.time_format
                },
                shouldBeUpdated: false
            })
        }

    }

    filterItems = (q) => {
        function escapeRegExp(s) {
            return s.replace(/[-/\\^$*+?.()|[\]{}]/g, "\\$&");
        }

        const words = q
        .split(/\s+/g)
        .map(s => s.trim())
        .filter(s => !!s);
        const hasTrailingSpace = q.endsWith(" ");
        const searchRegex = new RegExp(
            words
            .map((word, i) => {
                if (i + 1 === words.length && !hasTrailingSpace) {
                    // The last word - ok with the word being "startswith"-like
                    return `(?=.*\\b${escapeRegExp(word)})`;
                } else {
                    // Not the last word - expect the whole word exactly
                    return `(?=.*\\b${escapeRegExp(word)}\\b)`;
                }
            })
            .join("") + ".+",
            "gi"
        );
        // console.log('Words: ', words)
        let filteredArray = [];
        this.state.timeZones.filter(item => {
            let imamIme = searchRegex.test(item.TimeZone);
            searchRegex.lastIndex = 0;
            return imamIme ? filteredArray.push(item) : null;
        });
        this.setState({
            filteredTimeZones: filteredArray
        })
    };

    doSubmit = async () => {
        this.setState({spinnerActive: true});

        try{
            const stripeResult = await http.post('api/user/' + this.props.user.id + '/locals',{
                "timezone": this.state.selectedTimeZone.TimeZone,
                "offset": this.state.selectedTimeZone.UTC_Jan_1_2020,
                "date_format": this.state.selectedDateFormat,
                "time_format": this.state.selectedTimeFormat
            }, {headers: {authorization: getJwt()}})
            // console.log('Evo rezultata za create stripe customer: ', stripeResult)
            await this.props.updateUserFromServer();
            toastr.success("Data successfully saved.")

            await this.setState({spinnerActive: false, shouldBeUpdated: true})
        }catch(ex){
            toastr.error("Error Code #10043: Saving was unsuccessful, please try again.");
            await this.setState({spinnerActive: false})
        }
    };

    clickCancel = () => {
        this.setState({
            selectedTimeZone: {
                TimeZone: this.state.dataBeforeChange.selectedTimeZone.TimeZone,
                UTC_Jan_1_2020: this.state.dataBeforeChange.selectedTimeZone.UTC_Jan_1_2020
            },
            selectedDateFormat: this.state.dataBeforeChange.selectedDateFormat,
            selectedTimeFormat: this.state.dataBeforeChange.selectedTimeFormat,
        })
    }

    render() {
        return (
            <div className='panel-container profile-tab date-time'>
                <h3>Date & Time</h3>
                <div className='flex-column full-width'>
                    <Select
                        items={this.state.filteredTimeZones}
                        itemRenderer={(item, index) => <MenuItem
                            key={index}
                            onClick={() => {
                                this.setState({
                                    selectedTimeZone: item
                                })
                            }}
                            text={item.TimeZone + ' (UTC ' + (item.UTC_Jan_1_2020 > 0 ? '+' : '') + item.UTC_Jan_1_2020 + ')'}
                        />}
                        filterable={true}
                        onQueryChange={this.filterItems}
                        resetOnClose={true}
                    >
                        <p style={{fontSize: 12, marginBottom: 5}}>Country</p>
                        <Button
                            className={'country-selector'}
                            text={this.state.selectedTimeZone.TimeZone + ' (UTC '+ (this.state.selectedTimeZone.UTC_Jan_1_2020 > 0 ? '+' : '') + this.state.selectedTimeZone.UTC_Jan_1_2020 + ')'}
                            rightIcon="caret-down">
                        </Button>

                    </Select>
                    <Select
                        items={[
                            'DD-MM-YYYY',
                            'MM-DD-YYYY',
                            'YYYY-MM-DD'
                        ]}
                        itemRenderer={(item, index) => <MenuItem
                            key={index}
                            onClick={() => {
                                this.setState({
                                    selectedDateFormat: item
                                })
                            }}
                            text={item}
                        />}
                        filterable={false}
                        resetOnClose={true}
                    >
                        <p style={{fontSize: 12, marginBottom: 5}}>Date format</p>
                        <Button
                            className={'country-selector'}
                            text={this.state.selectedDateFormat}
                            rightIcon="caret-down">
                        </Button>

                    </Select>
                    <Select
                        items={[
                            '24-hour clock',
                            'AM/PM'
                        ]}
                        itemRenderer={(item, index) => <MenuItem
                            key={index}
                            onClick={() => {
                                this.setState({
                                    selectedTimeFormat: item
                                })
                            }}
                            text={item}
                        />}
                        filterable={false}
                        resetOnClose={true}
                    >
                        <p style={{fontSize: 12, marginBottom: 5}}>Time format</p>
                        <Button
                            className={'country-selector'}
                            text={this.state.selectedTimeFormat}
                            rightIcon="caret-down">
                        </Button>

                    </Select>
                </div>
                <div className="edit-profile-tab-buttons flex-row">

                    <button
                        disabled={
                            ( this.state.selectedTimeZone.TimeZone !== this.state.dataBeforeChange.selectedTimeZone.TimeZone ) ||
                            ( this.state.selectedTimeZone.UTC_Jan_1_2020 !== this.state.dataBeforeChange.selectedTimeZone.UTC_Jan_1_2020 ) ||
                            ( this.state.selectedDateFormat !== this.state.dataBeforeChange.selectedDateFormat ) ||
                            ( this.state.selectedTimeFormat !== this.state.dataBeforeChange.selectedTimeFormat ) ?
                            false : true
                        }
                        className="btn-white-border"
                        onClick={this.clickCancel}
                        type="button"
                    >
                        Cancel
                    </button>

                    <button
                        id="save"
                        disabled={
                            ( this.state.selectedTimeZone.TimeZone !== this.state.dataBeforeChange.selectedTimeZone.TimeZone ) ||
                            ( this.state.selectedTimeZone.UTC_Jan_1_2020 !== this.state.dataBeforeChange.selectedTimeZone.UTC_Jan_1_2020 ) ||
                            ( this.state.selectedDateFormat !== this.state.dataBeforeChange.selectedDateFormat ) ||
                            ( this.state.selectedTimeFormat !== this.state.dataBeforeChange.selectedTimeFormat ) ||
                            this.state.spinnerActive ? false : true
                        }
                        className="btn-action"
                        onClick={this.doSubmit}
                    >
                        {
                            this.state.spinnerActive ?
                                <React.Fragment>
                                    Save
                                    <i className='fa fa-spin fa-spinner'></i>
                                </React.Fragment>
                                :
                                'Save'
                        }

                    </button>
                </div>
            </div>
        )
    }
}

export default DateTime;